import * as React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HeadProvider } from "react-head";

import type { EnvValues } from "./interfaces/customTypes";
import "./utils/silenceConsoleNoise";
import App from "./App";

const rawPreloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

if (!rawPreloadedState) {
  throw new Error("Missing window.__PRELOADED_STATE__");
}

let preloadedState: { app: string; data: EnvValues };
try {
  const decoded = new TextDecoder().decode(Uint8Array.from(atob(rawPreloadedState), c => c.charCodeAt(0)));
  preloadedState = JSON.parse(decoded);
} catch (e) {
  throw new Error("Failed to decode window.__PRELOADED_STATE__: " + e);
}

const container = document.getElementById("root")!!;
const envValues = preloadedState.data;
const app = (
  <BrowserRouter>
    <HeadProvider>
      <App envValues={envValues} />
    </HeadProvider>
  </BrowserRouter>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
